import React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Grid, IconButton, Typography } from '@mui/material'

import InputText from 'src/components/Input/TextInput'
import { setExaminerDetail } from 'src/redux/slices/eExamination'
import { getError } from './event'
import { openDialog } from 'src/redux/slices/alertDialog'
import ChangeEmailForm from '../ChangeEmail'
import useLocalStorage from '@rehooks/local-storage'
import { userType } from 'src/components/UpdateProfileDialog/UpdateProfileForm/model'

const TextField = ({
  index,
  obj,
  label,
  isDisabled = false,
  sm = 6,
  md = 'unset',
  maxlength = 'unset',
  required = true,
}) => {
  const [user] = useLocalStorage('user')
  const isAgent = user.userType === userType.AGENT
  const dispatch = useDispatch()
  const { value, formError, showFormError, duplicatedError } = useSelector(
    (state) => ({
      value: state.eExamination.examiners[index][obj],
      formError: state.eExamination.formError[index],
      showFormError: state.eExamination.showFormError,
      duplicatedError: state.eExamination.duplicatedError,
    }),
    shallowEqual
  )

  const handleOpenChangeEmailDialog = () => {
    dispatch(
      openDialog({
        type: 'custom',
        customWidth: 520,
        content: <ChangeEmailForm index={index} />,
      })
    )
  }

  const isEmailField = obj === 'email' && !isAgent

  return (
    <>
      <Grid item md={md} sm={sm} xs={12}>
        <InputText
          sx={{
            height: 50,
            background: '#FFFFFF',
            border: '1px solid #CCCCCC',
            px: '12px',
            '&.Mui-disabled': { background: '#F5F5F5' },
            '&.Mui-disabled input': {
              WebkitTextFillColor: 'rgba(0, 0, 0, 0.70)',
            },
          }}
          id={`${obj}-${index}`}
          placeholder="กรุณากรอก"
          labelText={label}
          value={value || ''}
          required={required}
          isShowTextError={showFormError}
          textError={
            getError(formError, obj) || duplicatedError?.[index]?.[obj]
          }
          disabled={isDisabled || isEmailField}
          onChange={(e) =>
            dispatch(setExaminerDetail({ index, obj, value: e.target.value }))
          }
          maxlength={maxlength}
          endAdornment={
            isEmailField && (
              <IconButton
                edge="end"
                onClick={handleOpenChangeEmailDialog}
                sx={{ p: 0 }}
              >
                <Typography
                  color="primary"
                  fontWeight="medium"
                  sx={{ textDecoration: 'underline' }}
                >
                  แก้ไข
                </Typography>
              </IconButton>
            )
          }
        />
      </Grid>
    </>
  )
}

export default TextField
